<!-- ALERT & CONFIRM DIALOG -->
<p-toast></p-toast>

<p-confirmDialog [style]="{width: '450px'}"></p-confirmDialog>

<!-- OVERLAY SCREEN-->
<div *ngIf="blocked " class="overlay">
    <img src="assets/layout/images/tovlogo.png" alt="{{translations.lbl_loading}}" class="loading-image" />
    <span style="color: white; font-size: large;">{{translations.lbl_loading}}</span>
</div>

<!-- MAIN CONTAINER -->
<div class="card" *ngIf="this.translations != null">

    <!-- TOOLBAR -->
    <p-toolbar styleClass="p-mb-4">
        <ng-template pTemplate="left">

            <!-- BACK BUTTON -->
            <button pButton pRipple label="{{translations.lbl_go_Back}}" icon="pi pi-chevron-left"
                class="p-button-warning p-mr-2" (click)="goBack()"></button>

            <!-- SAVE BUTTON -->
            <!--button pButton pRipple icon="pi pi-save" class="p-button-success p-mr-2"
                [pTooltip]="translations.lbl_add + ' ' + translations.lbl_or + ' ' + translations.lbl_update + ' ' + translations.lbl_documents"
                (click)="redirectToVideoUpload(null)"></button-->
        </ng-template>
    </p-toolbar>

    <!-- MAIN CONTENT -->
    <div class="p-grid">

        <!-- CREATE FORM -->
        <div class="p-col-12 p-md-6">
            <p-panel [header]="translations.lbl_detail + ' ' + translations.lbl_coordination">
                <div class="p-fluid">
                    <ng-container *ngTemplateOutlet="infoTemplateCreate"></ng-container>
                </div>
            </p-panel>
        </div>
    </div>

    <!-- CARD -->
    <ng-template #infoTemplateCreate [formGroup]="globalUserDataFormParams">

        <!-- GUIDE INFO -->
        <div class="subTitle p-d-flex p-ai-center p-jc-between p-py-2">
            <span>{{ translations.lbl_guide }}</span>
            <ng-container *ngIf="globalUserDataFormParams.get('selectedGuide').value != null; else noSelectionGuide">
                <span class="p-text-bold">
                    {{ globalUserDataFormParams.get('selectedGuide').value || " " }}</span>
            </ng-container>

            <ng-template #noSelectionGuide>
                <span class="p-text-bold">{{ translations.lbl_without + ' ' + translations.lbl_guide}}</span>
            </ng-template>
        </div>

        <!-- COORDINATION INFO -->
        <div class="subTitle p-d-flex p-ai-center p-jc-between p-py-2">
            <span>{{ translations.lbl_coordination }}</span>
            <ng-container
                *ngIf="globalUserDataFormParams.get('selectedCoordination').value != null; else noSelectionCoordination">
                <span class="p-text-bold">
                    {{ globalUserDataFormParams.get('selectedCoordination').value || " " }}</span>
            </ng-container>

            <ng-template #noSelectionCoordination>
                <span class="p-text-bold">{{ translations.lbl_without + ' ' + translations.lbl_coordination }}</span>
            </ng-template>
        </div>

    </ng-template>

    <!-- FORM TRANSFER -->
    <div class="card">
        <!-- TABLE -->
        <p-table #dt1 [value]="globalUserDataFormParams.get('selectedListVideos').value" [columns]="lstCols"
            *ngIf="globalUserDataFormParams.get('selectedListVideos').value != null" selectionMode="single"
            dataKey="video.videoId" [rows]="5" [paginator]="true" [rowsPerPageOptions]="[5, 10, 20]"
            [globalFilterFields]="['video.name','video.description','video.type','video.link','video.releaseTime','video.vendor']"
            [rowHover]="true"
            currentPageReportTemplate="{{translations.lbl_showing}} {first} {{translations.lbl_of}} {last} {{translations.lbl_records}}"
            [showCurrentPageReport]="true" responsive="true" editMode="row">

            <!-- CAPTION -->
            <ng-template pTemplate="caption">
                <div class="p-d-flex p-ai-center p-jc-between">
                    <h5 class="p-m-0">
                        {{ (translations.lbl_administration + ' ' + translations.lbl_or + ' ' +
                        translations.lbl_upload + ' ' + translations.lbl_videos) | uppercase }}
                    </h5>


                    <span class="p-input-icon-left">
                        <i class="pi pi-search"></i>
                        <input pInputText type="text" (input)="dt1.filterGlobal($event.target.value, 'contains')"
                            placeholder="{{translations.lbl_search}}..." />
                    </span>
                </div>

                <span class="p-input-icon-left">
                    <button type="button" pButton pRipple icon="pi pi-plus" (click)="redirectToVideoUpload(null)" class="p-mr-4 z-5"
                    pTooltip="{{lbl_new_record}}" tooltipPosition="bottom" [disabled]="isDisabled"></button>

                    <button type="button" pButton pRipple icon="pi pi-file-excel" (click)="exportExcel()"
                        class="p-button-success p-mr-2 z-5" pTooltip="XLS" tooltipPosition="bottom"
                        *ngIf="device != '2'"></button>
                    <button type="button" pButton pRipple icon="pi pi-file-pdf" (click)="exportPdf()"
                        class="p-button-warning p-mr-2" pTooltip="PDF" tooltipPosition="bottom"
                        *ngIf="device != '2'"></button>
                    <button pButton pRipple label="" icon="pi pi-sync" class="p-button-danger p-mr-2 z-5"
                        (click)="reloadGetListVideos()"></button>
                </span>
            </ng-template>

            <!-- HEADER -->
            <ng-template pTemplate="header">
                <tr>

                    <th colspan="2" pSortableColumn="video.name" pTooltip="{{ translations.lbl_name}}">
                        {{ translations.lbl_name }} <p-sortIcon field="video.key"></p-sortIcon>
                    </th>

                    <th colspan="2" pSortableColumn="video.description" pTooltip="{{ translations.lbl_description}}">
                        {{ translations.lbl_description }} <p-sortIcon field="video.description"></p-sortIcon>
                    </th>

                    <th pSortableColumn="video.type" pTooltip="{{ translations.lbl_type }}">
                        {{ translations.lbl_type }} <p-sortIcon field="video.type"></p-sortIcon>
                    </th>

                    <th pSortableColumn="video.releaseTime" pTooltip="{{ translations.lbl_release_time}}">
                        {{ translations.lbl_release_time }} <p-sortIcon field="video.releaseTime"></p-sortIcon>
                    </th>

                    <th pSortableColumn="video.vendor" pTooltip="{{ translations.lbl_vendor }}">
                        {{ translations.lbl_vendor }} <p-sortIcon field="video.vendor"></p-sortIcon>
                    </th>

                    <th pTooltip="{{ translations.lbl_options }}">
                        {{ translations.lbl_options }}
                    </th>
                </tr>
            </ng-template>

            <!-- BODY -->
            <ng-template pTemplate="body" let-data let-editing="editing" let-ri="rowIndex">
                <tr [pSelectableRow]="data" [pEditableRow]="data" [formGroup]="globalUserDataFormParams">


                    <td colspan="2"
                        pTooltip="{{ (data.video?.name || (translations.lbl_without + ' ' + translations.lbl_name)) | uppercase }}">
                        {{ (data.video?.name || (translations.lbl_without + ' ' + translations.lbl_name))
                        }}
                    </td>

                    <td colspan="2"
                        pTooltip="{{ (data.video?.description || (translations.lbl_without + ' ' + translations.lbl_description)) | uppercase }}">
                        {{ (data.video?.description || (translations.lbl_without + ' ' + translations.lbl_description))
                        }}
                    </td>

                    <td
                        pTooltip="{{ (data.video?.type || (translations.lbl_without + ' ' + translations.lbl_type)) | uppercase }}">
                        {{ (data.video?.type || (translations.lbl_without + ' ' + translations.lbl_type))
                        }}
                    </td>

                    <td
                        pTooltip="{{ (data.video?.releaseTime || (translations.lbl_without + ' ' + translations.lbl_release_time)) | uppercase }}">
                        {{ (data.video?.releaseTime || (translations.lbl_without + ' ' + translations.lbl_release_time))
                        }}
                    </td>

                    <td
                        pTooltip="{{ (data.video?.vendor || (translations.lbl_without + ' ' + translations.lbl_vendor)) | uppercase }}">
                        {{ (data.video?.vendor || (translations.lbl_without + ' ' + translations.lbl_vendor))
                        }}
                    </td>

                    <td>
                        <button pButton pRipple icon="pi pi-pencil" class="p-button-rounded p-button-warning p-mr-2"
                            (click)="redirectToVideoUpload(data)">
                        </button>

                        <!-- DELETE BUTTON -->
                        <button pButton pRipple icon="pi pi-trash" class="p-button-rounded p-button-danger p-mr-2"
                            (click)="deletePropertyDocument(data)" pTooltip="{{translations.lbl_delete}}"></button>
                    </td>
                </tr>

            </ng-template>

            <!-- EMPTY -->
            <ng-template pTemplate="emptymessage" let-columns>
                <tr>
                    <td [attr.colspan]="columns ? columns.length : 1">
                        {{translations.lbl_no_records_found}}
                    </td>
                </tr>
            </ng-template>

            <!-- SUMMARY -->
            <ng-template pTemplate="summary">
                <div class="p-d-flex">
                    <span class="p-mr-2">{{ translations.lbl_total }}</span>
                    <span class="p-text-bold p-mr-2">
                        {{ (globalUserDataFormParams.get('selectedListVideos').value).length || 0 }}
                    </span>
                    <span>{{ translations.lbl_records }}</span>
                </div>
            </ng-template>

        </p-table>
    </div>
</div>